import React from 'react'
import { FaBars } from "react-icons/fa";
import { useAdminStore } from '../../../store/userStore';

import AlertIcon from '../../common/AlertIcon';
import { useSocketStore } from '../../../store/socketStore';


const AdminHeader = () => {
  const { adminInfo, adminLogoutAction } = useAdminStore(state => state)
  const { disconnectSocket } = useSocketStore((state) => state)

  /* Methods */
  const onClickAdminLogout = () => {
    disconnectSocket() // 소켓 연결 해제

    adminLogoutAction() // 프론트엔드 관리자 로그아웃
  }

  return (
    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
      {/* Sidebar Toggle (Topbar) */}
      <button id="sidebarToggleTop" className="btn btn-link text-secondary rounded-circle mr-3">
        <FaBars />
      </button>

      {/* Topbar Navbar */}
      <ul className="navbar-nav ml-auto">
        <li className="nav-item">
          <div className="">
            <AlertIcon userInfo={adminInfo} isAdmin={true} />
          </div>
        </li>

        <li className="nav-item">
          <div className="nav-link">
            <span className="mr-2 d-none d-lg-inline text-gray-600">{adminInfo?.name} 님</span>
          </div>
        </li>

        <li className='nav-item'>
          <button className='btn btn-outline-dark' onClick={onClickAdminLogout}>로그아웃</button>
        </li>
      </ul>
    </nav>
  )
}

export default AdminHeader